import { useState } from "react";
import { useAsync } from "react-async";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import { getDistrictsByDirectorUserId } from '../../../../api/services/directorService';
import District from "../../../../api/models/district";
import { useHistory } from "react-router-dom";
import Spinner from "../../../spinner";

const fetchDistrictsByDirectorUserId = async ({ id }: any) => {
    return await getDistrictsByDirectorUserId(id);
}

const DashboardWidgetDirectorDistricts = ({ user }: DashboardProps): JSX.Element => {
    const [districts, setDistricts] = useState<District[]>([]);
    const id: number = user.userId!;
    const history = useHistory();

    const asyncDistricts = useAsync({
        promiseFn: fetchDistrictsByDirectorUserId, id,
        onResolve: (r) => setDistricts(r.data)
    });

    const navigateToDistrictCalendar = (districtId: number | undefined, districtName: string): void => {
        history.push(`admin/districts/${districtId}/calendar`, { districtName: districtName });
    }

    return (
        <>
            <div className={`${DashboardPropsDefaults.containerClassNames} dashboard-widget-half`}>
                <div className="dashboard-widget-title pb-1">
                    <h3>District Calendars ({districts && districts.length})</h3>
                </div>
                <div className={`${DashboardPropsDefaults.contentClassNames}`}>
                    <Spinner show={asyncDistricts.isPending} />
                    {!asyncDistricts.isPending && (
                        <>
                            {districts && districts.length > 0 && (
                                <>
                                    {districts.map((d: District) => (
                                        <div key={`district-${d.districtId}-calendar`} className="mb-2 cursor-pointer">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <a onClick={() => navigateToDistrictCalendar(d.districtId, d.name)}>
                                                {d.name}
                                            </a>
                                        </div>
                                    ))}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default DashboardWidgetDirectorDistricts;